let _canvas;
let _marker;
let _circle;
let _infoWindow;
let _hasAutocomplete = false;
let _hasMarker = false;
let _hasInfoWindow = false;
let _hasConfirmLocationCallback = false;
let _hasRemoveLocationCallback = false;
let _hasDrawGeometryCallback = false;
let _hasAutoCompleteGetPlaceCallback = false;
let _hasMarkerChangeCallback = false;
let _confirmLocationClassName = "save-location";
let _removeLocationClassName = "remove-location";
let _drawGeometryLocationClassName = "draw-geometry";

function _isEmpty(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function _onClickCanvas(latLng) {
  _marker.setPosition(latLng);
  _marker.setVisible(true);
}

function _onPlaceChangedAutoComplete(autocomplete) {
  // hide marker
  if (_hasMarker) {
    _marker.setVisible(false);
  }

  let place = autocomplete.getPlace();
  if (!place.geometry) {
    // User entered the name of a Place that was not suggested and
    // pressed the Enter key, or the Place Details request failed.
    window.alert("No details available for input: '" + place.name + "'");
    return;
  }

  // If the place has a geometry, then present it on a map.
  if (place.geometry.viewport) {
    _canvas.fitBounds(place.geometry.viewport);
  } else {
    _canvas.setCenter(place.geometry.location);
  }

  _canvas.setZoom(15);

  // display marker
  if (_hasMarker) {
    _marker.setPosition(place.geometry.location);
    _marker.setVisible(true);
  }

  return place;
}

function _removeCircle() {
  if (_circle !== undefined) {
    _circle.setMap(null);
  }
}

function _removeInfoWindow() {
  if (_infoWindow !== undefined) {
    _infoWindow.close();
  }
}

function _initializeCircle(coordinate, visibleCircle) {
  // remove existing objects
  _removeCircle();
  _removeInfoWindow();

  // draw circle
  _circle = new google.maps.Circle({
    center: {
      lat: coordinate.lat,
      lng: coordinate.lng
    },
    radius: coordinate.rad,
    editable: true,
    draggable: true
  });

  // fill on canvas
  if (visibleCircle) {
    _circle.setMap(_canvas);

    // create window
    _infoWindow = new google.maps.InfoWindow();

    function showInfoWindow() {
      const content =
        "Latitude: " +
        _circle.getCenter().lat() +
        "<br>" +
        "Longitude: " +
        _circle.getCenter().lng() +
        "<br>" +
        "Radius: " +
        _circle.getRadius().toString();

      // Set the info window's content and position.
      _infoWindow.setContent(content);
      _infoWindow.setPosition(_circle.getBounds().getNorthEast());
      _infoWindow.open(_canvas);
    }

    // attach listener
    _circle.addListener("radius_changed", showInfoWindow);
    _circle.addListener("center_changed", showInfoWindow);
  }
}

class MaverickMap {
  constructor(config) {
    // mapId: string
    // lat: double
    // lng: double
    // autocomplete: bool
    // marker: bool
    // infoWindow: bool
    // confirmLocationCallback: callback
    // removeLocationCallback: callback
    // drawGeometryCallback: callback
    // autoCompleteGetPlaceCallback: callback
    // markerChangeCallback: callback
    // confirmLocationClassName: string
    // removeLocationClassName: string
    // drawGeometryLocationClassName: string
    this.config = config;

    _hasAutocomplete =
      config.autocomplete !== undefined && config.autocomplete === true;
    _hasMarker = config.marker !== undefined && config.marker === true;
    _hasInfoWindow =
      config.infoWindow !== undefined && config.infoWindow === true;
    _hasConfirmLocationCallback = config.confirmLocationCallback !== undefined;
    _hasRemoveLocationCallback = config.removeLocationCallback !== undefined;
    _hasDrawGeometryCallback = config.drawGeometryCallback !== undefined;
    _hasAutoCompleteGetPlaceCallback =
      config.autoCompleteGetPlaceCallback !== undefined;
    _hasMarkerChangeCallback = config.markerChangeCallback !== undefined;
    _confirmLocationClassName =
      config.confirmLocationClassName !== config.confirmLocationClassName
        ? config.confirmLocationClassName
        : _confirmLocationClassName;
    _removeLocationClassName =
      config.removeLocationClassName !== config.removeLocationClassName
        ? config.removeLocationClassName
        : _removeLocationClassName;
    _drawGeometryLocationClassName =
      config.drawGeometryLocationClassName !==
      config.drawGeometryLocationClassName
        ? config.drawGeometryLocationClassName
        : _drawGeometryLocationClassName;
  }

  initialize() {
    // reset
    _canvas = undefined;
    _marker = undefined;
    _circle = undefined;
    _infoWindow = undefined;

    if (_isEmpty(this.config)) {
      return;
    }

    _canvas = new google.maps.Map(document.getElementById(this.config.mapId), {
      center: {
        lat: this.config.lat,
        lng: this.config.lng
      },
      zoom: 15,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });

    _canvas.addListener("bounds_changed", function() {
      const container = document.getElementsByClassName("pac-container")[0];
      if (container !== undefined && container !== null) {
        container.setAttribute("style", "z-index: 2000;");
      }
    });

    // Marker
    if (_hasMarker) {
      _marker = new google.maps.Marker({
        map: _canvas,
        anchorPoint: new google.maps.Point(0, -29)
      });

      // attach event listener
      _canvas.addListener("click", e => {
        const latLng = e.latLng;
        _onClickCanvas(latLng);
        if (_hasMarkerChangeCallback) {
          this.config.markerChangeCallback({
            lat: latLng.lat(),
            lng: latLng.lng()
          });
        }
      });
    }

    // Autocomplete
    if (_hasAutocomplete) {
      _canvas.controls[google.maps.ControlPosition.TOP_LEFT].push(
        document.getElementById("pac-card")
      );

      const autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("pac-input")
      );

      // Bind the map's bounds (viewport) property to the autocomplete object,
      // so that the autocomplete requests use the current map bounds for the
      // bounds option in the request.
      autocomplete.bindTo("bounds", _canvas);

      // Set the data fields to return when the user selects a place.
      autocomplete.setFields([
        "address_components",
        "formatted_address",
        "geometry",
        "name",
        "place_id"
      ]);

      // attach event listener
      autocomplete.addListener("place_changed", _ => {
        const place = _onPlaceChangedAutoComplete(autocomplete);
        if (_hasAutoCompleteGetPlaceCallback) {
          this.config.autoCompleteGetPlaceCallback(place);
        }
      });
    }

    const customControl = document.getElementById("gmap-custom-control");
    if (customControl) {
      // EventHandler: Save Location
      const saveLocationControl = customControl.getElementsByClassName(
        _confirmLocationClassName
      );
      if (_hasConfirmLocationCallback && saveLocationControl.length > 0) {
        saveLocationControl[0].addEventListener("click", () => {
          let coordinate = {};
          if (_marker !== undefined) {
            coordinate.lat = _marker.getPosition().lat();
            coordinate.lng = _marker.getPosition().lng();
          } else if (_circle !== undefined) {
            coordinate.lat = _circle.getCenter().lat();
            coordinate.lng = _circle.getCenter().lng();
            coordinate.rad = _circle.getRadius();
          }

          // callback
          this.config.confirmLocationCallback(coordinate);
        });
      }

      // EventHandler: Remove Location
      const removeLocationControl = customControl.getElementsByClassName(
        _removeLocationClassName
      );
      if (_hasRemoveLocationCallback && removeLocationControl.length > 0) {
        removeLocationControl[0].addEventListener("click", () => {
          // remove objects
          this.hideMarker();
          _removeCircle();
          _removeInfoWindow();

          // callback
          this.config.removeLocationCallback();
        });
      }

      // EventHandler: Draw Geometry
      const drawGeometryControl = customControl.getElementsByClassName(
        _drawGeometryLocationClassName
      );
      if (_hasDrawGeometryCallback && drawGeometryControl.length > 0) {
        drawGeometryControl[0].addEventListener("click", () => {
          _initializeCircle(
            {
              lat: _canvas.getCenter().lat(),
              lng: _canvas.getCenter().lng(),
              rad: 700
            },
            true
          );
        });
      }
    }
  }

  showInfoWindow(position, content) {
    if (_hasInfoWindow) {
      // initialize if empty
      if (_infoWindow === undefined) {
        _infoWindow = new google.maps.InfoWindow();
      }

      let latLng = new google.maps.LatLng(
        position.latitude,
        position.longitude
      );

      // Set the info window's content and position.
      _infoWindow.setContent(content);
      _infoWindow.setPosition(latLng);
      _infoWindow.open(_canvas);

      _canvas.setCenter(latLng);
      _canvas.setZoom(20);
    }
  }

  showMarker(center) {
    if (_hasMarker) {
      _marker.setPosition(center);
      _marker.setVisible(true);
    }
    _canvas.setCenter(center);
    _canvas.setZoom(15);
  }

  hideMarker() {
    if (_hasMarker) {
      _marker.setVisible(false);
    }
    _canvas.setZoom(15);
  }

  setCircleCenter(center, radius, visibleCircle) {
    if (_circle === undefined) {
      _initializeCircle(
        {
          lat: center.lat(),
          lng: center.lng(),
          rad: radius
        },
        visibleCircle
      );
    } else {
      _circle.setCenter(center);
      _circle.setRadius(radius);
    }
    _canvas.fitBounds(_circle.getBounds());
    _canvas.setZoom(12);
  }

  get isInRadius() {
    let result = false;
    if (_circle !== undefined) {
      result =
        google.maps.geometry.spherical.computeDistanceBetween(
          _marker.getPosition(),
          _circle.getCenter()
        ) <= _circle.getRadius();
      if (!result) {
        _marker.setVisible(false);
      }
    }
    return result;
  }
}

export default MaverickMap;



// WEBPACK FOOTER //
// ./src/plugins/google/map.js